import generateFilterForQuery from "./common/_tools";

export class DealListPageQuery {
  static build(query: any, pathData: any = {}, by_delivery: boolean = false) {
    const filter = generateFilterForQuery(query);

    const result: any = {
      columns: DealListPageQuery.COLUMNS,
      from: DealListPageQuery.FROM,
      from_as: DealListPageQuery.FROM_AS,
      joins: DealListPageQuery.JOINS,
      page_size: DealListPageQuery.PAGE_SIZE,
      page: parseInt(query.page) || 1,
      order: [
        by_delivery
          ? { $desc: [DealListPageQuery.COLUMNS["expected_delivery_date"]] }
          : query.sortDirection == "desc"
          ? {
              $desc_nulls_last: [
                DealListPageQuery.COLUMNS[query.sortField || "created_at"],
              ],
            }
          : {
              $asc: [
                DealListPageQuery.COLUMNS[query.sortField || "created_at"],
              ],
            },
        { $asc: ["deal.id"] },
      ],
      ...pathData,
    };

    if (filter.length > 1) {
      result.where = { $and: filter };
    } else if (filter.length === 1) {
      result.where = filter[0];
    }

    return result;
  }

  static COLUMNS: any = {
    id: "deal.id",
    expected_delivery_date: "deal.expected_delivery_date",
    name: "deal.name",
    pipeline_name: "pipe.name",
    status_name: "status.name",
    status_id: "status.id",
    status_color: "status.color",
    client_name: "client.name",
    point_city: "city.name",
    point_address: "delivery_points.address",
    manager_name: "manager.name",
    created_at: "deal.created_at",
    updated_at: "deal.updated_at",
    expected_payment_date: {
      $add: ["deal.expected_delivery_date", "pdp.period"],
    },
    weight: "deal.list_weight",
    price: "deal.list_price",
    mixcart_number: {
      $case: [
        [
          { $not: [{ $null: ["mixcart_deals.id"] }] },
          "mixcart_deals.mixcart_id",
        ],
        [
          { $not: [{ $null: ["mixcart_deals2.id"] }] },
          "mixcart_deals2.mixcart_id",
        ],
      ],
    },
    mixcart_is_reject: "mixcart_deals2.is_reject",
    mixcart_manual_processed: "mixcart_deals2.manual_processed",
    is_corrected: "deal.is_corrected",
    corrections_count: "dpcc.count",
    exported_to_1c: "deal.exported_to_1c",
    has_free_products: "dpc_with_samples.sapmle_count",
  };

  static FROM: string = "s:deals";
  static FROM_AS: string = "deal";

  static JOINS: any[] = [
    {
      join: "s:statuses",
      as: "status",
      on: {
        $eq: ["deal.status_id", "status.id"],
      },
    },
    {
      join: "s:pipelines",
      as: "pipe",
      on: {
        $eq: ["status.pipeline_id", "pipe.id"],
      },
    },
    {
      join: "s:clients",
      as: "client",
      on: {
        $eq: ["deal.client_id", "client.id"],
      },
    },
    {
      join: "s:payment_deferment_periods",
      type: "left",
      as: "pdp",
      on: { $eq: ["pdp.id", "client.payment_deferment_period_id"] },
    },
    {
      join: "s:delivery_points",
      as: "delivery_points",
      on: {
        $eq: ["deal.delivery_point_id", "delivery_points.id"],
      },
    },
    {
      join: "s:cities",
      as: "city",
      on: {
        $eq: ["delivery_points.city_id", "city.id"],
      },
    },
    {
      join: "s:employees",
      as: "manager",
      on: {
        $eq: ["deal.manager_id", "manager.id"],
      },
    },
    {
      join: "s:mixcart_deals",
      type: "left",
      as: "mixcart_deals",
      on: {
        $and: [
          { $eq: ["mixcart_deals.deal_id", "deal.id"] },
          { $eq: ["mixcart_deals.is_reject", { $: false }] },
        ],
      },
    },
    {
      join: "s:mixcart_deals",
      type: "left",
      as: "mixcart_deals2",
      on: {
        $and: [
          { $eq: ["mixcart_deals2.deal_id", "deal.id"] },
          { $eq: ["mixcart_deals2.is_reject", { $: true }] },
        ],
      },
    },
    {
      join: {
        columns: {
          deal_id: "dpc.deal_id",
          sapmle_count: { $count: "dpc.id" },
        },
        from: "s:deal_product_containers",
        from_as: "dpc",
        joins: [
          {
            join: "s:product_containers",
            type: "left",
            as: "pc",
            on: {
              $eq: ["pc.id", "dpc.product_container_id"],
            },
          },
        ],
        groups: ["dpc.deal_id"],
        where: {
          $or: [
            { $eq: ["dpc.is_sample", { $: true }] },
            { $eq: ["pc.is_sample", { $: true }] },
          ],
        },
      },
      type: "left",
      as: "dpc_with_samples",
      on: { $eq: ["dpc_with_samples.deal_id", "deal.id"] },
    },
    {
      join: {
        columns: {
          deal_id: "dpcc.deal_id",
          count: { $count: "dpcc.id" },
        },
        from: "s:deal_product_containers_corrections",
        from_as: "dpcc",
        groups: ["dpcc.deal_id"],
      },
      type: "left",
      as: "dpcc",
      on: { $eq: ["dpcc.deal_id", "deal.id"] },
    },
  ];

  static PAGE_SIZE: number = 100;
}
